import {AbstractControl, ValidatorFn} from '@angular/forms';

export function InvalidPasswordValidator(isInvalid: boolean): ValidatorFn {
  return (c: AbstractControl): { [key: string]: any } | null => {
    if (isInvalid) {
      return {password: 'invalid'};
    }

    return null;
  };
}
